import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class PurgeService {

    private resourceInterneUrl = 'api/interne/purge';

    constructor(private http: Http) { }

    purge(campaign: string): Observable<Response> {
        return this.http.delete(`${this.resourceInterneUrl}/${campaign}`);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/purge/purge.service.ts